import script from "./menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu.vue?vue&type=script&setup=true&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=d135c0fc&lang=scss"

const __exports__ = script;

export default __exports__